import type { FileChangeEventView } from '@/lib/api/generated/model';

/**
 * One entry where overlapping runs each recorded the same unattributed change
 * (service spec 126). When two tasks' runs share the workspace and neither can
 * claim a change, each run's capture keeps it against itself, so the log holds
 * it twice. Read newest first (the order the history endpoints return and
 * `HistoryPane` keeps), a run of adjacent unattributed events for the
 * same path and of the same kind is one change seen twice: the newest stands
 * for it. Anything between them — a person, a credited agent, another kind of
 * change — breaks the run, so a real sequence of changes is never folded.
 */
export function mergeUnattributedRepeats(
  events: readonly FileChangeEventView[],
): FileChangeEventView[] {
  const merged: FileChangeEventView[] = [];
  for (const event of events) {
    const previous = merged.at(-1);
    const repeat =
      previous !== undefined &&
      event.actor.kind === 'unattributed' &&
      previous.actor.kind === 'unattributed' &&
      previous.path === event.path &&
      previous.event_type === event.event_type;
    if (!repeat) merged.push(event);
  }
  return merged;
}
